import React from "react";
import "./ConsentModal.scss";
import { Sparks } from "../../assets/Icons/Sparks";

// AI Usage consent modal displayed on first app load
const ConsentModal = ({ onAgree }) => {
  return (
    <div className="consent-modal-overlay">
      <div className="consent-modal">
        <div className="consent-modal-icon">
          <Sparks width="24" height="24" color="#000" />
        </div>

        <h2 className="consent-modal-title">Disclaimer</h2>

        <p className="consent-modal-text">
          EY does not intentionally collect any sensitive personal data from you
          via the Tool. The Tool’s intention is not to process such information.
        </p>

        <p className="consent-modal-text">
          Accordingly, you should not enter any unnecessary personal information
          or any sensitive personal data (including government identifiers such
          as tax file numbers or social security numbers/national identification
          numbers), client confidential information (except client entity
          names), audit secrets, state secrets, trade secrets, or anything that
          would violate professional secrecy or confidentiality rules or that
          would be considered abusive/irrelevant in the Tool.
        </p>

        <p className="consent-modal-text">
          By selecting "Agree & Continue", you confirm that you have the
          necessary rights and permissions to enter, upload, and use EY Business
          Information including client data within this AI System. You are responsible for
          ensuring that any information entered is appropriately authorized and
          used in compliance with applicable EY policies, confidentiality
          obligations, independence requirements, data protection standards, and
          professional requirements
        </p>

        <div className="consent-modal-actions">
          <button className="consent-modal-button" onClick={onAgree}>
            Agree & Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentModal;
